import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import * as firebase from 'firebase/app';
import { Subject } from 'rxjs/Subject';
import "rxjs/add/operator/map";
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  sizeSubject: Subject<any>;
  user: Observable<firebase.User>;

  constructor( public afAuth: AngularFireAuth, public router: Router) {
    this.sizeSubject = new Subject();
    this.user = afAuth.authState;

  }
  filterBy(size: string) {
    this.sizeSubject.next(size);
  }

  logOut(event) {

    var router = this.router;

    this.afAuth.auth.signOut().then(function(res) {

      console.log('signed out');
      router.navigate(['./']);

    }, function(error) {
      // rejection
      var errorMessage = error.message;
      console.log("Error" + errorMessage);

    });
  }

  ngOnInit() {
    var router = this.router;
    this.afAuth.auth.onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        console.log('user signed in');

      } else {
        // No user is signed in.
        console.log('user signed out');
        router.navigate(['/']);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts